import React, { useRef, useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { useSelector, useDispatch } from "react-redux";
import { AnimatePresence } from "framer-motion/dist/framer-motion";

import { setIsLoading } from "redux/loader/action";
import { set_gah_new_card } from "redux/game/action";
import GAHResult from "./screens/GAHResult";
import GAHJoining from "./screens/GAHJoining";
import GAHPrePlay from "./screens/GAHPrePlay";
import GAHPlaying from "./screens/GAHPlaying";
import GAHReading from "./screens/GAHReading";
import GAHFooter from "./components/GAHFooter";
import GAHEvaluating from "./screens/GAHEvaluating";
import CardModal from "./components/CardModal";
import LoserModal from "./components/LoserModal";
import GiphyModal from "./components/GiphyModal";
import WinnerModal from "./components/WinnerModal";
import GAHOver from "./screens/GAHOver";

const GAH = () => {
  const dispatch = useDispatch();
  const {
    gameReducer: {
      currentUser,
      gah_new_card,
      roomObj: {
        id: roomId,
        users,
        game_state: {
          status,
          prompt,
          played_cards,
          player_hands,
          active_player,
          game_parameters: { score_to_win } = {}
        } = {}
      }
    },
    paramsReducer
  } = useSelector((state) => state);

  const cardsRef = useRef(null);
  const [giphyModal, setGiphyModal] = useState(false);
  const [cardModal, setCardModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState({});

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const playerObj = player_hands?.find(
    (player) => player.player_id === currentPlayer?.player_id
  );
  const isActivePlayer = () => active_player === currentPlayer?.player_id;

  const playerCard = played_cards?.find(
    (card) => card.player_id === currentPlayer.player_id
  );
  const winnerCard = played_cards?.find((card) => card.winner);

  const handleIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  useEffect(() => {
    if (status === "Playing") {
      cardsRef.current = playerObj.cards;
      dispatch(set_gah_new_card({ active: false, card: {} }));
    }
    if (status === "Joining") {
    }
  }, [status]);

  useEffect(() => {
    return Socket.addListener(
      "play-card",
      handle_play_card,
      handle_play_card_error
    );
  }, [cardsRef]);

  useEffect(() => {
    return Socket.addListener(
      "select-card",
      handle_loading,
      handle_loading_error
    );
  }, [cardsRef]);

  const handle_loading = (res) => {
    if (res) {
      handleIsLoading(false);
    }
  };

  const handle_loading_error = (err) => {
    handleIsLoading(false);
  };

  const handle_play_card = (res) => {
    if (res && res.room && !_.isEmpty(res.cardId)) {
      handleIsLoading(false);
      const player_cards = res.room.game_state.player_hands.find(
        (card) => card.player_id === currentPlayer.player_id
      ).cards;

      const newCard = player_cards.find((newCard) =>
        cardsRef.current.every((prevCard) => prevCard.id !== newCard.id)
      );
      setSelectedCard({});
      !_.isEmpty(newCard) &&
        dispatch(set_gah_new_card({ active: true, card: newCard }));
    }
  };
  const handle_play_card_error = (err) => {
    if (err) {
      handleIsLoading(false);
    }
  };

  const toggleGiphyModal = () => {
    setGiphyModal((prev) => !prev);
  };

  const toggleCardModal = () => {
    setCardModal((prev) => !prev);
  };

  const handleSelectCard = (card) => {
    setSelectedCard(card);
    toggleCardModal();
  };

  const handleConfirmCard = (id) => {
    handleIsLoading(true);
    toggleCardModal();
    const data = {
      action: "play-card",
      roomId: roomId,
      cardId: id,
      playerId: currentPlayer.player_id
    };
    Socket.sendMessage(data);
  };

  const handleWinner = () => {
    handleIsLoading(true);
    const data = {
      action: "select-card",
      roomId: roomId,
      cardId: selectedCard.id
    };
    Socket.sendMessage(data);
    setSelectedCard({});
  };

  const updateRoomForNextRound = () => {
    const data = {
      action: "update-status",
      roomId: roomId
    };
    Socket.sendMessage(data);
  };

  return (
    <div className="gah-wrapper">
      <div
        className={`main-container ${
          status === "Evaluating" ? "evaluating" : ""
        }`}
      >
        <AnimatePresence exitBeforeEnter>
          {status === "Joining" && <GAHJoining key="gah_1" users={users} />}
          {status === "PrePlay" && playerObj !== undefined && (
            <GAHPrePlay
              key="gah_2"
              roomId={roomId}
              status={status}
              playerObj={playerObj}
              isActivePlayer={isActivePlayer()}
            />
          )}
          {status === "Playing" && playerObj !== undefined && (
            <GAHPlaying
              key="gah_3"
              prompt={prompt}
              playerObj={playerObj}
              gah_new_card={gah_new_card}
              onSelectCard={handleSelectCard}
              isActivePlayer={isActivePlayer()}
            />
          )}
          {status === "Reading" && !_.isEmpty(played_cards) && (
            <GAHReading
              key="gah_4"
              roomId={roomId}
              prompt={prompt}
              status={status}
              isReading={true}
              playerObj={playerObj}
              played_cards={played_cards}
              isActivePlayer={isActivePlayer()}
            />
          )}
          {status === "Evaluating" && !_.isEmpty(played_cards) && (
            <GAHEvaluating
              key="gah_5"
              roomId={roomId}
              prompt={prompt}
              status={status}
              playerObj={playerObj}
              played_cards={played_cards}
              isActivePlayer={isActivePlayer()}
              onEvaluateCard={(card) => setSelectedCard(card)}
            />
          )}
          {status === "Result" && (
            <GAHResult
              key="gah_6"
              roomId={roomId}
              prompt={prompt}
              status={status}
              playerObj={playerObj}
              played_cards={played_cards}
              isActivePlayer={isActivePlayer()}
            />
          )}
          {status === "Over" && !_.isEmpty(winnerCard) && (
            <GAHOver
              key="gah_7"
              users={users}
              score={score_to_win}
              winnerCard={winnerCard}
            />
          )}
          {/* {status === "Over" && (
            <GAHJoining key="gah_7" isOver={true} users={users} />
          )} */}
        </AnimatePresence>
      </div>
      <GAHFooter toggleGiphyModal={toggleGiphyModal} />
      <AnimatePresence exitBeforeEnter>
        {giphyModal && (
          <GiphyModal key="gah_modal_1" toggleGiphyModal={toggleGiphyModal} />
        )}
        {cardModal && (
          <CardModal
            key="gah_modal_2"
            card={selectedCard}
            onConfirmCard={handleConfirmCard}
            toggleCardModal={() => {
              toggleCardModal();
              setSelectedCard({});
            }}
          />
        )}
        {gah_new_card.active && (
          <CardModal
            key="gah_modal_3"
            isNewCard={true}
            card={gah_new_card.card}
            onConfirmCard={() => dispatch(set_gah_new_card({ active: null }))}
            toggleCardModal={() => dispatch(set_gah_new_card({ active: null }))}
          />
        )}
        {status === "Evaluating" && !_.isEmpty(selectedCard) && (
          <CardModal
            key="gah_modal_4"
            isEvaluating={true}
            card={selectedCard}
            onConfirmCard={handleWinner}
            toggleCardModal={() => setSelectedCard({})}
          />
        )}
        {status === "Result" &&
          !_.isEmpty(playerCard) &&
          (playerCard.winner ? (
            <WinnerModal
              key="gah_modal_5"
              card={playerCard.card}
              onNextRound={updateRoomForNextRound}
            />
          ) : (
            <LoserModal key="gah_modal_6" card={playerCard.card} />
          ))}
      </AnimatePresence>
    </div>
  );
};

export default GAH;
